import CryptoJS from 'crypto-js';

export const hashPassword = (password) => {
    // Add a static salt for consistent hashing
    const salt = "your-static-salt-here"; // Should match backend salt
    // Use PBKDF2 with multiple iterations for better security
    return CryptoJS.PBKDF2(password, salt, {
        keySize: 256/32,
        iterations: 1000
    }).toString();
}; 